import React, { Component, useContext } from 'react';
import { DayPilot, DayPilotScheduler } from 'daypilot-pro-react';
import axios from 'axios';
import MuiAlert from '@material-ui/lab/Alert';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Snackbar from '@material-ui/core/Snackbar';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';
import { connect, useSelector } from 'react-redux';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Box, LinearProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Add, NavigateBefore, NavigateNext } from '@material-ui/icons';
import { getMyDate, getMyTime, getMyTime3, getMyTime2, getMyDate2 } from '../../../@jumbo/utils/commonHelper';
import { KeyboardDatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ViewEvent from './ViewEvent';
require('./App.css');

const breadcrumbs = [
  //  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  //  { label: <IntlMessages id={'pages.calendarPage'} />, isActive: true },
];
const useStyles = theme => ({
  formControl: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  input1: {
    height: 2,
    fontSize: '1em',
  },
  boxClass: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class ShiftPlanner extends Component {
  constructor(props) {
    super(props);
    //    const [openRes, setOpenRes] = React.useState(false);
    var hotels = [{ id: 18, name: 'Hotel Villa Magdalena' }]; //props.auth.authUser.hotels;
    const startdate = moment()
      .subtract(0, 'day')
      .format('YYYY-MM-DD');

    const enddate = moment()
      .add(6, 'day')
      .format('YYYY-MM-DD');
    // var hotels = this.props.auth.authUser.hotels;
    var myhotels = '';
    hotels.forEach(function(element, index) {
      var hid = element.id;
      if (myhotels != '') myhotels = myhotels + ',';
      myhotels = myhotels + hid;
    });

    var defaultLocale = 'en-en';
    defaultLocale = 'hr-hr';
    if (this.props.auth.authUser != null) {
      if (this.props.auth.authUser.cloudUser == 1) defaultLocale = 'hr-hr';
      else {
        if (this.props.auth.authUser.language == 'hr') defaultLocale = 'hr-hr';
      }
    }

    this.state = {
      //dynamicLoading: true,
      lastStart: '',
      lastEnd: '',
      // hotel_id: hotels[0].id,
      rowHeaderColumns: [
        { title: 'Osoba', display: 'name' },
        { title: 'Stanje', display: 'desc' },
      ],
      selData: {},
      myhotels: myhotels,
      viewMode: 0,
      viewGroup: -1,
      resources: [],
      startDate1: startdate,
      startDate: startdate,
      endDate1: enddate,
      running2: false,
      lastEvents: [],
      treeEnabled: true,
      days: 7,
      timeHeaders: [
        { groupBy: 'Day', format: 'dddd d.M' },
        { groupBy: 'Hour', format: 'H' },
      ],
      cellDuration: 60,
      cellWidth: 7,
      scale: 'CellDuration',
      errorConnection: false,
      selId: '',
      popunjenost: [],
      popunjenostStart: '',
      popunjenostEnd: '',
      viewEventVisible: false,
      selReservationId: '',
      selResTitle: '',
      locale: defaultLocale,
      resDetailsVisible: false,
    };

    this.eventClick = this.eventClick.bind(this);
    this.eventMove = this.eventMove.bind(this);
    this.eventResize = this.eventResize.bind(this);
    this.eventMoving = this.eventMoving.bind(this);
    this.eventCreate = this.eventCreate.bind(this);
    this.doRefresh = this.doRefresh.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.runAction = this.runAction.bind(this);
  }

  doRefresh() {
    //this.setState({ lastEvents: [], running2: false, lastStart: '' });

    //    args.async = true;

    var start = this.state.startDate1;
    var end = this.state.endDate1;

    const date1 = new Date(start);
    const date2 = new Date(end);
    const diffTime = Math.abs(date2 - date1);
    var days = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    //    this.scheduler.days = days;

    //    if (start != this.state.lastStart || end != this.state.lastEnd) {
    this.setState({ running2: true });

    if (
      this.state.popunjenostStart == '' ||
      this.state.popunjenostStart != getMyDate(start) ||
      this.state.popunjenostEnd != getMyDate(end)
    ) {
      var senddata = {};
      //if (this.props.auth.authUser.clouduser == 0)
      senddata = {
        Action: 'get_popunjenost',
        token: token,
        Version: 1,
        Data: {
          HotelId: this.state.myhotels,
          From: getMyDate(start),
          To: getMyDate(end),
        },
      };
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      axios.post(pmsUrl, senddata).then(res => {
        const data = res.data;
        if (data.Data != null)
          this.setState({ popunjenostStart: getMyDate(start), popunjenostEnd: getMyDate(end), popunjenost: data.Data });
      });
    }

    const token = localStorage.getItem('token');
    var senddata = {};
    //if (this.props.auth.authUser.clouduser == 0)
    senddata = {
      Action: 'get_shifts',
      token: token,
      Version: 1,
      Data: {
        HotelId: this.state.myhotels,
        group_id: this.state.viewGroup,
        From: start,
        To: end,
      },
    };
    /*                  else
      senddata = {
        Action: 'get_shifts',
        token: token,
        Version: 1,
        Data: {
          HotelId: this.state.myhotels,
          PeriodStart: start.toString().substring(0, 10),
          PeriodEnd: end.toString().substring(0, 10),
        },
      };*/

    console.log('url2: ' + pmsUrl);
    var self = this;
    var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      this.setState({ lastStart: start });
      this.setState({ lastEnd: end });
      const data = res.data;
      //            this.setState({ persons });
      var newevents = data.Data;
      if (data.Data != null && data.Data.Error != undefined) {
        this.setState({ errorConnection: true, running2: false });
      } else if (data.Data == null) {
        this.setState({ errorConnection: true, running2: false });
      } else {
        this.setState({ errorConnection: false });

        console.log(res);
        console.log(data);
        console.log(newevents);
        if (Array.isArray(newevents))
          newevents.forEach(function(item, index) {
            item['resource'] = item['pid'];
            item['osoba'] = item['osoba'];
            item['start'] = item['fromTime'];
            item['end'] = item['toTime'];
            let formattime = getMyTime(item['fromTime'], item['toTime']);
            let hours = getMyTime2(item['fromTime'], item['toTime']);
            let formattime2 = hours + 'h ';
            let tip = 'Dnevna';
            if (item['type'] == 0) {
              item['backColor'] = '#ffcd38';
            }
            if (item['type'] == 0 && getMyDate(item['fromTime']) != getMyDate(item['toTime']) && hours >= 6) {
              item['backColor'] = '#ff9800';
              tip = 'Noćna';
            }

            if (item['type'] == 1) {
              tip = 'Bolovanje';
              item['backColor'] = '#f6685e';
            }
            if (item['type'] == 2) {
              tip = 'Godišnji';
              item['backColor'] = '#d7e360';
            }
            item['Text'] = formattime2 + tip + '<BR/>' + formattime;

            // if (item['TextColor']!=null) item['textColor'] = '#ffffff';
          });

        let newResources = this.state.resources;
        newResources.forEach(function(item, index) {
          var isgroup = 0;
          if (String(item.id).substring(0, 5) == 'group') isgroup = 1;
          if (isgroup == 0) {
            let hours1 = 0,
              hours2 = 0,
              hours3 = 0,
              sd = days;

            newevents.forEach(function(item2, index2) {
              if (item2['resource'] == item['id']) {
                let hours = getMyTime2(item2['fromTime'], item2['toTime']);
                if (item2['type'] == 0) hours1 += hours;
                if (item2['type'] == 1) hours2 += 1;
                if (item2['type'] == 2) hours3 += 1;
                let firstday = 1;
                for (let i = 0; i < index2; i++)
                  if (
                    newevents[i]['resource'] == item2['resource'] &&
                    getMyDate(newevents[i]['fromTime']) == getMyDate(item2['fromTime'])
                  ) {
                    firstday = 0;
                    break;
                  }
                if (firstday == 1) sd--;
              }
            });
            item.desc = 'R: ' + hours1 + 'h, B: ' + hours2 + ', G: ' + hours3 + 'h' + ', SD: ' + sd;
          } else {
            item.children.forEach(function(item3, index3) {
              let hours1 = 0,
                hours2 = 0,
                hours3 = 0,
                sd = days;
              newevents.forEach(function(item2, index2) {
                if (item2['resource'] == item3['id']) {
                  let hours = getMyTime2(item2['fromTime'], item2['toTime']);
                  if (item2['type'] == 0) hours1 += hours;
                  if (item2['type'] == 1) hours2 += 1;
                  if (item2['type'] == 2) hours3 += 1;
                  let firstday = 1;
                  for (let i = 0; i <= index2 - 1; i++)
                    if (
                      newevents[i]['resource'] == item2['resource'] &&
                      getMyDate(newevents[i]['fromTime']) == getMyDate(item2['fromTime'])
                    ) {
                      firstday = 0;
                      break;
                    }
                  if (firstday == 1) sd--;
                }
              });
              item3.desc = 'R: ' + hours1 + 'h, B: ' + hours2 + ', G: ' + hours3 + ', SD: ' + sd;
            });
          }
        });
        this.setState({
          startDate: getMyDate(start),
          events: newevents,
          lastEvents: newevents,
          resources: newResources,
          days: days,
        });

        //this.scheduler.events = newevents;

        this.setState({ running2: false });
        try {
          //            args.loaded();
        } catch (e) {}
      }
    });
  }

  componentDidMount() {
    const { currentPage, setCurrentPage } = this.context;
    const { intl } = this.props;
    setCurrentPage(intl.formatMessage({ id: 'pages.timeline' }));

    DayPilot.Locale.register(
      new DayPilot.Locale('hr-hr', {
        dayNames: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
        dayNamesShort: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
        monthNames: [
          'Siječanj',
          'Veljača',
          'Ožujak',
          'Travanj',
          'Svibanj',
          'Lipanj',
          'Srpanj',
          'Kolovoz',
          'Rujan',
          'Listopad',
          'Studeni',
          'Prosinac',
          '',
        ],
        monthNamesShort: ['SIJ', 'VELJ', 'OŽU', 'TRA', 'SVI', 'LIP', 'SRP', 'KOL', 'RUJ', 'LIS', 'STU', 'PRO', ''],
        timePattern: 'HH:mm',
        datePattern: 'dd/MM/yyyy',
        dateTimePattern: 'dd/MM/yyyy HH:mm',
        timeFormat: 'Clock24Hours',
        weekStarts: 1,
      }),
    );

    var self = this;

    var rs1 = intl.formatMessage({ id: 'Izmjena...' });
    var rs2 = intl.formatMessage({ id: 'Kopiraj slijedeći dan' });
    var rs4 = intl.formatMessage({ id: 'Postavi kao bolovanje' });
    var rs5 = intl.formatMessage({ id: 'Postavi kao godišnji' });
    var rs5 = intl.formatMessage({ id: 'Postavi kao redovan rad' });
    var rs3 = intl.formatMessage({ id: 'Obriši' });

    /*if (this.props.auth.authUser.clouduser == 1) {
          var menu1 = new DayPilot.Menu({
            items: [
              {
                text: rs1,
                onClick: function(args) {
                  //            console.log(self.state.lastEvents);
                  var x = self.state.lastEvents.find(({ id }) => id === args.source.id());
                  //          console.log(x.bid);
                  self.setState({ selResTitle: x.bookingId });
                  self.setState({ selReservationId: x.bid });
                  self.setState({ resDetailsVisible: true });
                },
              },
            ],
          });
        }
        if (this.props.auth.authUser.clouduser == 0)*/ {
      var menu1 = new DayPilot.Menu({
        items: [
          {
            text: rs1,
            onClick: function(args) {
              var x = self.state.lastEvents.find(({ id }) => id === args.source.id());
              var myData = {
                date1: getMyDate(x.start),
                date2: getMyDate(x.end),
                time1: getMyTime3(x.start),
                time2: getMyTime3(x.end),
                osoba: x.osoba,
                type: x.type,
              };
              this.setState({ selId: args.source.id(), selData: myData, viewEventVisible: true });
              //            console.log(self.state.lastEvents);

              /*//          console.log(x.bid);
              self.setState({ selResTitle: x.bookingId });
              self.setState({ selReservationId: x.bid });
              self.setState({ resDetailsVisible: true });*/
            }.bind(this),
          },
          {
            text: rs2,
            onClick: function(args) {
              var r = window.confirm('Kopiraj na slijedeći dan?');
              if (r == true) {
                //var x = self.state.lastEvents.find(({ id }) => id === args.source.id());
                const token = localStorage.getItem('token');
                const senddata = {
                  Action: 'copy_shift',
                  token: token,
                  Data: {
                    HotelId: self.state.myhotels,
                    Id: args.source.id(),
                  },
                };

                //var pmsUrl = this.props.auth.authUser.pmsUrl;
                var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
                if (pmsUrl == '') return;
                self.setState({ running2: true });
                axios.post(pmsUrl, senddata).then(res => {
                  if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                    localStorage.setItem('token', res.data.newToken);
                  }
                  self.setState({ running2: false });
                  self.doRefresh();
                });
              }
            },
          },
          {
            text: rs3,
            onClick: function(args) {
              var r = window.confirm('Obriši?');
              if (r == true) {
                //var x = self.state.lastEvents.find(({ id }) => id === args.source.id());
                const token = localStorage.getItem('token');
                const senddata = {
                  Action: 'delete_shift',
                  token: token,
                  Data: {
                    HotelId: self.state.myhotels,
                    Id: args.source.id(),
                  },
                };

                //var pmsUrl = this.props.auth.authUser.pmsUrl;
                var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
                if (pmsUrl == '') return;
                self.setState({ running2: true });
                axios.post(pmsUrl, senddata).then(res => {
                  if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                    localStorage.setItem('token', res.data.newToken);
                  }
                  self.setState({ running2: false });
                  self.doRefresh();
                });
              }
            },
          },
        ],
      });
    }
    this.scheduler.contextMenu = menu1;

    const token = localStorage.getItem('token');
    const senddata = {
      Action: 'get_shift_resources',
      token: token,
      Data: {
        HotelId: this.state.myhotels,
        group_id: this.state.viewGroup,
      },
    };

    //var pmsUrl = this.props.auth.authUser.pmsUrl;
    var resources = {};
    var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
    if (pmsUrl == '') return;
    this.setState({ running2: true });
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      resources = res.data;
      if (resources.Data == null) {
        this.setState({ errorConnection: true });
      } else {
        this.setState({ resources: resources.Data });
        this.setState({ running2: false });
        this.setState({ errorConnection: false });
      }
    });

    /*const today = moment()
      .subtract(0, 'day')
      .format('YYYY-MM-DD');
    this.scheduler.scrollTo(today);*/
    this.doRefresh();
  }

  eventCreate(args) {
    let isgroup = 0,
      ishotel = 0;
    if (args.resource.substring(0, 5) == 'group') isgroup = 1;
    if (ishotel == 1 || isgroup == 1) {
      args.allowed = false;
      return;
    }

    let dateFrom = args.start;
    let dateTo = args.end;
    let rs1 = 'Kreiraj smjenu?';
    var r = window.confirm(rs1);
    if (r == true) {
      const senddata = {
        Action: 'create_shift',
        Data: {
          HotelId: this.state.myhotels,
          ResId: args.resource,
          fromTime: args.start,
          toTime: args.end,
        },
      };
      console.log(senddata);

      //var pmsUrl = this.props.auth.authUser.pmsUrl;
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      if (pmsUrl == '') return;
      this.setState({ running2: true });
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        let newId = res.data.newId;
        this.setState({ running2: false });
        this.doRefresh();
        var myData = {
          date1: getMyDate(args.start),
          date2: getMyDate(args.end),
          time1: getMyTime3(args.start),
          time2: getMyTime3(args.end),
          osoba: '',
        };
        // this.setState({ selId: newId, selData: myData, viewEventVisible: true });
      });
    }
  }

  handleChange(name, value) {
    if (value == null) return;
    this.setState({ [name]: value }, () => {
      //   this.updateRooms();
      if (name == 'startDate1' || name == 'endDate1') {
        this.doRefresh();
      }
    });

    if (name == 'viewGroup') {
      const senddata = {
        Action: 'get_shift_resources',
        Data: {
          HotelId: this.state.myhotels,
          group_id: value,
        },
      };

      //var pmsUrl = this.props.auth.authUser.pmsUrl;
      var resources = {};
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      this.setState({ running2: true });
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        resources = res.data;
        if (resources.Data == null) {
          this.setState({ errorConnection: true });
        } else {
          this.setState({ resources: resources.Data });
          this.scheduler.resources = resources.Data;
          this.scheduler.update();
          this.setState({ running2: false });
          this.setState({ errorConnection: false });
        }
      });
    }
    if (name == 'viewMode') {
      //  alert(value);
      var mydate = getMyDate(this.scheduler.getDate(this.scheduler.getScrollX()));
      if (value == 1) {
        this.setState({
          timeHeaders: [{ groupBy: 'Month' }, { groupBy: 'Day', format: 'd' }],
          cellDuration: 480,
          cellWidth: 15,
          scale: 'CellDuration',
        });
      }
      if (value == 0) {
        this.setState({
          timeHeaders: [
            { groupBy: 'Day', format: 'dddd d.M' },
            { groupBy: 'Hour', format: 'h' },
          ],
          cellDuration: 60,
          cellWidth: 7,
        });
      }
      this.doRefresh();
      /*if (value==1)
            this.scheduler.timeHeaders=[{ groupBy: 'Month' }, { groupBy: 'Day', format: 'd' }];*/
    }
  }
  eventMoving(args) {
    /*   if (this.props.auth.authUser.clouduser == 1) {
          args.allowed = false;
          return;
        }*/
    var isgroup = 0;
    var ishotel = 0;
    if (args.resource.substring(0, 5) == 'group') isgroup = 1;
    if (args.resource.substring(0, 5) == 'hotel') ishotel = 1;
    if (ishotel == 1 || isgroup == 1) args.allowed = false;
  }
  eventMove(args) {
    /* if (this.props.auth.authUser.clouduser == 1) {
          return;
        }*/
    const { intl } = this.props;
    var rs1 = 'Pomakni/Premjesti smjenu?';

    var r = window.confirm(rs1);
    if (r == true) {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'move_shift',
        token: token,
        Data: {
          HotelId: this.state.myhotels,
          Id: args.e.id(),
          fromTime: args.newStart,
          toTime: args.newEnd,
          ResId: args.newResource,
        },
      };
      console.log(senddata);

      //var pmsUrl = this.props.auth.authUser.pmsUrl;
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      this.setState({ running2: true });
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }

        this.setState({ running2: false });
        this.doRefresh();
      });
    } else args.preventDefault();
  }
  eventResize(args) {
    /*  if (this.props.auth.authUser.clouduser == 1) {
          args.preventDefault();
          return;
        }*/
    const { intl } = this.props;
    var rs1 = 'Promijeni smjenu?';

    var r = window.confirm(rs1);
    if (r == true) {
      const token = localStorage.getItem('token');
      const senddata = {
        Action: 'move_shift',
        token: token,
        Data: {
          HotelId: this.state.myhotels,
          Id: args.e.id(),
          fromTime: args.newStart,
          toTime: args.newEnd,
        },
      };

      //var pmsUrl = this.props.auth.authUser.pmsUrl;
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      if (pmsUrl == '') return;
      this.setState({ running2: true });
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }

        this.setState({ running2: false });
        this.doRefresh();
      });
    } else args.preventDefault();
  }

  runAction(event, action) {
    if (action == 'prev') {
      /*var curStart = this.state.dateStart;
            var newStart = moment(curStart).add(-10, 'day');
            this.setState({ dateStart: newStart });*/
      // this.createDays(newStart.format('YYYY-MM-DD'));
      let z = -7;
      if (this.state.viewMode == 1) z = -30;
      this.setState(
        prevState => {
          var x = prevState.startDate1,
            y = prevState.endDate1;
          x = getMyDate(moment(x).add(z, 'days'));
          y = getMyDate(moment(y).add(z, 'days'));
          return { startDate1: x, endDate1: y };
        },
        () => {
          this.doRefresh();
        },
      );
    }
    if (action == 'next') {
      let z = 7;
      if (this.state.viewMode == 1) z = 30;
      this.setState(
        prevState => {
          var x = prevState.startDate1,
            y = prevState.endDate1;
          x = getMyDate(moment(x).add(z, 'days'));
          y = getMyDate(moment(y).add(z, 'days'));
          return { startDate1: x, endDate1: y };
        },
        () => {
          this.doRefresh();
        },
      );
      //this.scheduler.scrollTo(this.scheduler.getDate(this.scheduler.getScrollX()).addDays(7));
    }
    if (action == 'today') {
      this.scheduler.scrollTo(DayPilot.Date.today());
    }
    if (action == 'newreservation') {
      this.props.history.push('/pages/quickreservation');
    }
  }

  eventClick(args) {
    //    setOpenRes(true);
    var myData = {
      date1: getMyDate(args.e.data.start),
      date2: getMyDate(args.e.data.end),
      time1: getMyTime3(args.e.data.start),
      time2: getMyTime3(args.e.data.end),
      osoba: args.e.data.osoba,
      type: args.e.data.type,
    };
    this.setState({ selId: args.e.id(), selData: myData, viewEventVisible: true });
  }

  render() {
    const { ...config } = this.state;
    const { classes } = this.props;
    const pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
    //  var pmsUrl = this.props.auth.authUser.pmsUrl;

    if (pmsUrl == '') return;
    return (
      <>
        <GridContainer>
          <Grid item xs={12}>
            <Box className={classes.boxClass}>
              <Button
                variant="contained"
                color="primary"
                onClick={e => this.runAction(e, 'prev')}
                startIcon={<NavigateBefore />}
              />
              {this.scheduler != null && (
                <KeyboardDatePicker
                  margin="small"
                  id="date-picker-dialog1"
                  format="DD/MM/yyyy"
                  autoOk="true"
                  style={{ width: 150 }}
                  value={this.state.startDate1}
                  onChange={date => {
                    this.handleChange('startDate1', getMyDate(date));
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              )}
              {this.scheduler != null && (
                <KeyboardDatePicker
                  margin="small"
                  id="date-picker-dialog2"
                  format="DD/MM/yyyy"
                  autoOk="true"
                  style={{ width: 150 }}
                  value={this.state.endDate1}
                  onChange={date => {
                    this.handleChange('endDate1', getMyDate(date));
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              )}

              <Button
                variant="contained"
                color="primary"
                onClick={e => this.runAction(e, 'next')}
                startIcon={<NavigateNext />}
              />
              <TextField
                id="viewMode"
                name="viewMode"
                margin="small"
                select
                defaultValue=""
                value={this.state.viewMode}
                onChange={event => this.handleChange('viewMode', event.target.value)}>
                <MenuItem value={0}>Tjedni</MenuItem>
                <MenuItem value={1}>Mjesečni</MenuItem>
              </TextField>
              <TextField
                id="viewGroup"
                name="viewGroup"
                margin="small"
                select
                defaultValue=""
                value={this.state.viewGroup}
                onChange={event => this.handleChange('viewGroup', event.target.value)}>
                <MenuItem value={-1}>Svi</MenuItem>
                <MenuItem value={1}>Kuhinja</MenuItem>
                <MenuItem value={2}>Restoran</MenuItem>
                <MenuItem value={3}>Domaćinstvo</MenuItem>
                <MenuItem value={4}>Recepcija</MenuItem>
              </TextField>

              {this.state.errorConnection && (
                <Alert severity="error">
                  <IntlMessages id={'error.connection'} />
                </Alert>
              )}

              <DayPilotScheduler
                {...config}
                onBeforeCellRender={args => {
                  if (args.cell.start.getDayOfWeek() === 6 || args.cell.start.getDayOfWeek() === 0) {
                    args.cell.backColor = '#ffcccc';
                  }
                  if (args.cell.start >= DayPilot.Date.today() && args.cell.end <= DayPilot.Date.today().addDays(1)) {
                    args.cell.backColor = '#d9ead3';
                  }
                }}
                onBeforeEventRender={args => {
                  args.data.barHidden = true;
                  args.data.html = '<div>' + args.data.Text + '</div>';
                  args.data.bubbleHtml = '<div>' + args.data.Text + '</div>';
                }}
                onEventClick={args => {
                  this.eventClick(args);
                }}
                onEventMoving={args => {
                  this.eventMoving(args);
                }}
                onBeforeTimeHeaderRender={args => {
                  if (this.state.viewMode == 0) {
                    if (args.header.level == 0) {
                      let popunjenost = '';
                      for (let i = 0; i < this.state.popunjenost.length; i++) {
                        if (this.state.popunjenost[i].D == args.header.start.toString('yyyy-M-d')) {
                          popunjenost = '(' + this.state.popunjenost[i].P + '%)';
                          break;
                        }
                      }

                      args.header.html = '<b>' + args.header.start.toString('dddd d.M.') + '</b> ' + popunjenost;
                      //args.header.html = args.header.start.toString('yyyy-M-d') + '<br/>' + popunjenost;
                    }
                    if (args.header.level == 1) {
                      if (args.header.start.getHours() % 2 != 0) args.header.html = '';
                      else args.header.html = '<small>' + args.header.start.getHours() + '</small>';
                    }
                  }
                }}
                onBeforeRowHeaderColumnRender={args => {
                  //args.row.columns[0].html = Math.random();
                }}
                onEventResize={args => {
                  this.eventResize(args);
                }}
                onEventMove={args => {
                  this.eventMove(args);
                }}
                onEventResizing={args => {
                  args.allowed = true;
                }}
                onTimeRangeSelected={args => {
                  this.eventCreate(args);
                }}
                onScroll={args => {
                  args.async = true;

                  var start = args.viewport.start;
                  var end = args.viewport.end;

                  if (start != this.state.lastStart || end != this.state.lastEnd) {
                    this.setState({ running2: true });
                    const token = localStorage.getItem('token');
                    var senddata = {};
                    //if (this.props.auth.authUser.clouduser == 0)
                    senddata = {
                      Action: 'get_shifts',
                      token: token,
                      Version: 1,
                      Data: {
                        HotelId: this.state.myhotels,
                        group_id: this.state.viewGroup,
                        From: start.toString().substring(0, 10),
                        To: end.toString().substring(0, 10),
                      },
                    };
                    /*                  else
                  senddata = {
                    Action: 'get_shifts',
                    token: token,
                    Version: 1,
                    Data: {
                      HotelId: this.state.myhotels,
                      PeriodStart: start.toString().substring(0, 10),
                      PeriodEnd: end.toString().substring(0, 10),
                    },
                  };*/

                    console.log('url2: ' + pmsUrl);
                    var self = this;

                    axios.post(pmsUrl, senddata).then(res => {
                      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                        localStorage.setItem('token', res.data.newToken);
                      }
                      this.setState({ lastStart: start });
                      this.setState({ lastEnd: end });
                      const data = res.data;
                      //            this.setState({ persons });
                      var newevents = data.Data;
                      if (data.Data != null && data.Data.Error != undefined) {
                        this.setState({ errorConnection: true, running2: false });
                      } else if (data.Data == null) {
                        this.setState({ errorConnection: true, running2: false });
                      } else {
                        this.setState({ errorConnection: false });

                        console.log(res);
                        console.log(data);
                        console.log(newevents);
                        if (Array.isArray(newevents))
                          newevents.forEach(function(item, index) {
                            item['resource'] = item['pid'];
                            item['start'] = item['fromTime'];
                            item['end'] = item['toTime'];
                            let formattime = getMyTime(item['fromTime'], item['toTime']);
                            let hours = getMyTime2(item['fromTime'], item['toTime']);
                            let formattime2 = hours + 'h ';
                            item['Text'] = formattime2 + item['Text'] + '<BR/>' + formattime;

                            // if (item['TextColor']!=null) item['textColor'] = '#ffffff';
                          });

                        let newResources = this.state.resources;
                        newResources.forEach(function(item, index) {
                          let hours1 = 0,
                            hours2 = 0,
                            hours3 = 0;
                          newevents.forEach(function(item2, index2) {
                            let hours = getMyTime2(item2['fromTime'], item2['toTime']);
                            if (item2['type'] == 0) hours1 += hours;
                            if (item2['type'] == 1) hours2 += hours;
                            if (item2['type'] == 2) hours3 += hours;
                          });

                          item.desc = hours1 + ' h rada<br/>' + hours2 + ' h bolovanja ' + hours3 + ' h godišnji';
                        });
                        this.setState({ lastEvents: newevents, resources: newResources });

                        args.events = newevents;
                        this.setState({ running2: false });
                        try {
                          args.loaded();
                        } catch (e) {}
                      }
                    });
                  } else {
                    args.events = this.state.lastEvents;

                    try {
                      args.loaded();
                    } catch (e) {}
                  }
                }}
                ref={component => {
                  this.scheduler = component && component.control;
                }}
              />
            </Box>
          </Grid>
        </GridContainer>
        <ViewEvent
          Id={this.state.selId}
          selData={this.state.selData}
          open={this.state.viewEventVisible}
          doRefresh={p => {
            this.doRefresh();
          }}
          setState={p => {
            this.setState(p);
          }}
        />
        {this.state.running2 && <LinearProgress />}
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

ShiftPlanner.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(ShiftPlanner)));
